import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  get_SalaryScale,
  get_empDetail_dropDown_data,
  RegisterSlaryScale,
} from "../../../services/employeeApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Container,
  Modal,
  Row,
  Form,
  Col,
  Table,
  Button,
  Spinner,
} from "react-bootstrap";
import Card from "../../../components/Card";
import { GetUserInfo } from "../../../utils/permissionChecker";
import { toast } from "react-toastify";
const SalaryScale = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setFormError("");
  };
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    gradeId: "",
    stepId: "",
    salary: 0,
    status: 1,
    created_by: currentUser,
    updated_by: currentUser,
  });
  const RegisterSalaryScaleMutation = useMutation(async (newData) => {
    try {
      const result = await RegisterSlaryScale(newData);
      if (result) {
        queryClient.invalidateQueries("get_SalaryScale");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });

  const getdropDownDataQuery = useQuery(["get_grade_Steps"], () =>
    get_empDetail_dropDown_data()
  );
  const getScaleQuery = useQuery(["get_SalaryScale"], () => get_SalaryScale());
  if (getdropDownDataQuery.isLoading || getScaleQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getdropDownDataQuery.isError) {
    return <div>Error: {getdropDownDataQuery.error.message}</div>;
  }

  if (getScaleQuery.isError) {
    return <div>Error: {getdropDownDataQuery.error.message}</div>;
  }
  const scale = getScaleQuery.data;
  const dropDownData = getdropDownDataQuery.data;
  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    if (!formData.gradeId || !formData.stepId || !formData.salary) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    handleCloseModal();
    try {
      setIsSubmitting(true);
      await RegisterSalaryScaleMutation.mutate(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const maxStepNumber = Object.values(scale).reduce((max, steps) => {
    const stepNumbers = Object.keys(steps).map((step) =>
      parseInt(step.split(" ")[1])
    );
    return Math.max(max, ...stepNumbers);
  }, 0);

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <Card className="card-block card-stretch card-height">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center p-3">
                  <h5 className="font-weight-bold">Salary Scale List</h5>
                  <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <Button
                      variant="btn btn-info btn-sm m-2"
                      onClick={() => handleShowModal()}
                    >
                      {t("add_new_scale")}
                    </Button>
                  </div>
                </div>
                <Table
                  className="data-tables"
                  responsive
                  style={{ width: "100%" }}
                >
                  <thead className="light">
                    <tr>
                      <th>Grade</th>
                      {Array.from(
                        { length: maxStepNumber },
                        (_, index) => index + 1
                      ).map((step) => (
                        <th key={step}>Step {step}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(scale).map(([grade, steps]) => (
                      <tr key={grade}>
                        <td>{grade}</td>
                        {Array.from(
                          { length: maxStepNumber },
                          (_, index) => index + 1
                        ).map((step) => (
                          <td key={step}>{steps[`step ${step}`] || "--"}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">Add new scale </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <Form.Label
                    htmlFor="inputPosition"
                    className="font-weight-bold text-muted"
                  >
                    {t("grade")}
                  </Form.Label>
                  <select
                    id="inputPosition"
                    className="form-select form-control choicesjs"
                    value={formData.gradeId}
                    onChange={(e) => handleInputChange(e, "gradeId")}
                  >
                    <option value="" hidden disabled>
                      Select grade
                    </option>
                    {dropDownData.Grade.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.name}
                      </option>
                    ))}
                  </select>
                </Form.Group>

                <Form.Group>
                  <Form.Label
                    htmlFor="inputPosition"
                    className="font-weight-bold text-muted"
                  >
                    {t("step")}
                  </Form.Label>
                  <select
                    id="inputPosition"
                    className="form-select form-control choicesjs"
                    value={formData.stepId}
                    onChange={(e) => handleInputChange(e, "stepId")}
                  >
                    <option value="" hidden disabled>
                      Select step
                    </option>
                    {dropDownData.Step.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.name}
                      </option>
                    ))}
                  </select>

                  <Form.Label className="text-secondary">Salary</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter salary per month"
                    value={formData.salary}
                    onChange={(e) => handleInputChange(e, "salary")}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button variant="btn-primary">
              {" "}
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              onClick={(e) => handleButtonSubmit(e)}
              variant="btn btn-info"
            >
              Register
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SalaryScale;
